import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ColourBorder from "../General-UI/ColourBorder";
import { selectCurrentUser, selectMyGuid } from "slices/authSlice";
import {
  getInviteAvailability,
  resetJoinSlice,
  selectInviteEffice,
  tryEnterNewRoot,
} from "slices/joinSlice";
import Spinner from "components/General-UI/Spinner";
import QuickJoin from "./NoSignIn/QuickJoin";
import JoinSignIn from "./WithSignIn/JoinSignIn";
import NoCigar from "./NoCigar/NoCigar";
import history from "constants/history";
import FullLogoSmall from "graphics/Branding/FullLogoSmall";
import { goToEffice } from "slices/efficeTreeSlice";
import { setGuestInfo } from "slices/generalSlice";
import { getLocation } from "slices/efficeCacheSlice";
import { isRootEffice } from "helpers/efficeHelpers";
import { loadAudioSounds } from "helpers/sounds";
import { makeGUID } from "helpers/randomHelpers";

const JoinInPage = ({
  match: {
    params: { code },
  },
}) => {
  const dispatch = useDispatch();
  const [inviteLoaded, setInviteLoaded] = useState(false);
  const inviteEffice = useSelector(selectInviteEffice);
  const currentUser = useSelector(selectCurrentUser);
  const isRoot = isRootEffice(inviteEffice);
  const guid = useSelector(selectMyGuid);

  const postConfirm = useCallback(
    async (name = null) => {
      try {
        await getLocation(inviteEffice.id);
        window.log("Already a part of this node");
        goToEffice(inviteEffice.id);
      } catch (e) {
        window.log("NOT a part of this node. Continuing Join In");
        if (isRoot) await tryEnterNewRoot(code);
        else {
          loadAudioSounds();
          history.push(`/join/${code}`);
          dispatch(
            setGuestInfo({
              node: inviteEffice,
              code,
              name,
              guid: guid ? guid : makeGUID(),
            })
          );
        }
      }
    },
    [dispatch, isRoot, inviteEffice, code, guid]
  );

  useEffect(() => {
    async function beforeUnload() {
      try {
        let nodeId = await getInviteAvailability(code);
        await getLocation(nodeId);
        window.log("Already a part of this node");
        goToEffice(nodeId);
      } catch (e) {
        window.log("NOT Already a part of this node. Remaining in JoinInPage.");
      } finally {
        setInviteLoaded(true);
      }
    }
    beforeUnload();

    return () => dispatch(resetJoinSlice());
  }, [dispatch, code]);

  return inviteLoaded ? (
    <div className="signInComponent">
      <ColourBorder />
      <div className="whiteContainer signInBackground">
        <div
          className="logoCreatePic"
          onClick={() => {
            history.push("/");
          }}
        >
          <FullLogoSmall />
        </div>
        <div className="row nice-centre-row joinIn">
          {inviteEffice ? (
            currentUser ? (
              <QuickJoin
                inviteEffice={inviteEffice}
                postConfirm={postConfirm}
              />
            ) : (
              <JoinSignIn
                inviteEffice={inviteEffice}
                isRoot={isRoot}
                postConfirm={postConfirm}
              />
            )
          ) : (
            <NoCigar />
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className="vh-100">
      <Spinner />
    </div>
  );
};

export default JoinInPage;
